import styled from 'styled-components';

const Container = styled.div`
  background: white;
  padding: 20px;
  overflow: hidden;
`;
export default Container;
